export const CK_HASH = "70fd52c207055dfb82ca85a765c4ef91";
export const BACK_URL = "https://jaecoo-irkutskaya.ru";
export const RESERVE_COOKIES = 'current:::typ=typein|||src=(direct)|||mdm=(direct)|||cmp=|||cnt=|||trm=^#^#';

export const WIDGET_KEY = 'jaecoo-msk'; // check with the manager
const MOD_ID = 'e1025446'; // check with the manager or in script of calltouch
const SITE_ID = 19058; // check with the manager
